import { useCustomSession } from "shared/context/CustomSessionContext";
import type { HubOverviewPageRouteParams } from "shared/types/HubPageRouteParamsOverviewPage";
import PageComponent from "hub/src/components/common/PageComponent";
import PromoBanner from "hub/src/components/overview/PromoBanner";
import UserDetail from "hub/src/components/overview/UserDetail";
import type { HubRouteConfig } from "hub/src/routes/RouteConfigWrapper";

const OverviewPage = (
  routeConfig: HubRouteConfig<HubOverviewPageRouteParams>,
) => {
  const session = useCustomSession();

  return (
    <PageComponent>
      <PageComponent.Header />
      <PageComponent.Content>
        {session.society?.abbreviation === "TESAWG" && <PromoBanner />}
        <UserDetail routeConfig={routeConfig} />
      </PageComponent.Content>
    </PageComponent>
  );
};

export default OverviewPage;
